import { keepPreviousData } from "@tanstack/react-query";

import { getClosingScanFailed } from "@/api/audit-api";
import type { ClosingScanFailedResponse } from "@/schemas";
import { useCancellingQuery } from "@/hooks/use-cancelling-query";

const REFETCH_INTERVAL = 15 * 1000;

export interface GetClosingScanFailedProps {
	pageNumber: number;
	pageSize: number;
	enabled: boolean;
}

export const CLOSING_SCAN_FAILED_QUERY_KEY = "closing-scan-failed";

export const useClosingScanFailed = ({ pageNumber, pageSize, enabled }: GetClosingScanFailedProps) => {
	const queryKey = [CLOSING_SCAN_FAILED_QUERY_KEY, pageNumber, pageSize];

	const queryFn = () => getClosingScanFailed({ pageNumber, pageSize });

	const { data, isLoading, error, refetch } = useCancellingQuery<ClosingScanFailedResponse>({
		queryKey,
		queryFn,
		enabled,
		placeholderData: keepPreviousData,
		refetchInterval: REFETCH_INTERVAL,
	});

	return {
		data,
		isLoading,
		error,
		refetch,
	};
};
